import classes from './Page404.module.scss';

import { Button, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import IconHome from '@tabler/icons-react/IconHome';
import IconRouteOff from '@tabler/icons-react/IconRouteOff';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';

function Page404() {
  const { t } = useLanguage();

  return (
    <main className={classes.page} aria-labelledby="not-found-title">
      <section className={classes.card}>
        <div className={classes.visual} aria-hidden="true">
          <span className={classes.errorCode}>404</span>
          <ThemeIcon className={classes.routeIcon} size={54} radius="xl">
            <IconRouteOff size={27} stroke={1.8} />
          </ThemeIcon>
        </div>

        <Stack align="center" gap={8}>
          <Title id="not-found-title" order={1} className={classes.title}>
            {t('page404.message')}
          </Title>
          <Text className={classes.description}>
            {t('page404.description')}
          </Text>
          <Button
            component={Link}
            to="/"
            color="green"
            size="md"
            mt="md"
            leftSection={<IconHome size={18} />}
            className={classes.homeButton}
          >
            {t('page404.home')}
          </Button>
        </Stack>
      </section>
    </main>
  );
}

export default Page404;
